import React from 'react'
import { useSelector } from 'react-redux'

import { Align, Button, Heading, Margin, Popup, Spacer } from 'component-library-next'

import { selectLetterRequestId } from '@app/modules/Messages/store/selectors'
import { useCancelLetterRequestMutation } from '@app/queries/CancelLetterRequest/CancelLetterRequest.queries'
import { refetchPostponedLetterRequestsQuery } from '@app/queries/PostponedLetterRequests/PostponedLetterRequests.queries'
import { usePostponeLetterRequestMutation } from '@app/queries/PostponeLetterRequest/PostponeLetterRequest.queries'

type Props = {
  closePopUp: () => void
  sendAnswer: () => void
}

export const RequestedLetterNotAddedPopUp = ({ closePopUp, sendAnswer }: Props) => {
  const [postponeLetterRequest] = usePostponeLetterRequestMutation({
    refetchQueries: [refetchPostponedLetterRequestsQuery()]
  })
  const [cancelRequest] = useCancelLetterRequestMutation({
    refetchQueries: [refetchPostponedLetterRequestsQuery()]
  })

  const letterRequestId: any = useSelector(selectLetterRequestId)

  const handlePostpone = async () => {
    sendAnswer()
    await postponeLetterRequest({ variables: { letterRequestId } })
  }

  const handleCancelRequest = async () => {
    sendAnswer()
    await cancelRequest({
      variables: {
        letterRequestId
      }
    })
  }

  return (
    <Popup onCloseButtonClick={() => closePopUp()}>
      <Align direction={Align.directions.center} textAlign={Align.textAligns.center}>
        <Heading size={Heading.sizes.small} color={Heading.colors.black}>
          Möchten Sie ein Schreiben in naher Zukunft für den Kunden aufsetzen?
        </Heading>
        <span>
          Der Kunde hat ein Schreiben beauftragt. Sie haben der Antwort noch kein Schreiben
          angefügt.
        </span>
      </Align>
      <Spacer />
      <Align direction={Align.directions.center}>
        <Margin>
          <Button onClick={() => handlePostpone()} color={Button.colors.secondary}>
            Ja, Schreiben später aufsetzen
          </Button>
        </Margin>
        <Margin>
          <Button onClick={() => handleCancelRequest()} color={Button.colors.minor}>
            Nein, Schreiben ablehnen
          </Button>
        </Margin>
      </Align>
    </Popup>
  )
}
